import React from "react";
import data from "../../../template/copy.json";
import "../../css/article.scss";

const Article = ({ article, x }) => {
  return (
    <div className="article" style={{ left: x(new Date(article.date)) }}>
      <div>
        <a href={article.link} className="article-title-link">
          <p className="article-title">{article.title}</p>
        </a>
        <p className="article-author">Written by {article.author}</p>
        <p className="article-date">Published: {article.date}</p>
        <p className="article-content">{article.text}</p>
      </div>
    </div>
  );
};

export default Article;
